import { InputType } from 'config'

export const defaultInputs: Record<string, InputType> = {
  useMainKey: {
    inputType: 'togglebutton',
    title: 'Do you want to use Nexys Credentials?',
    required: true,
  },
  enabled: {
    inputType: 'toggle',
    title: 'Enabled',
    required: true,
  },
  title: {
    inputType: 'text',
    type: 'text',
    title: 'Title',
    required: true,
  },
}
